export default __webpack_public_path__ + "static/media/panel4.e02daee7.jpg";